import { api } from "./axios";
export const oauthApi = {
  GmailCallback: (code: string) => api.get(`/oauth/gmail/callback?code=${code}`),
  ConnectGmail: () => api.get("/oauth/gmail/connect"),
  getEmailStatus: () => api.get("/oauth/email/status"),
  DisconnectGmail: () => api.put("/oauth/gmail/revoke"),
  OutlookCallback: (code: string) => api.get(`/oauth/outlook/callback?code=${code}`),
  ConnectOutlook: () => api.get("/oauth/outlook/connect"),
  DisconnectOutlook: () => api.put("/oauth/outlook/revoke"),
};